"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCarousel = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../../../theme/icons");
const ImageCarousel_styles_1 = require("./ImageCarousel.styles");
const ImageCarousel = ({ slides, isExpanded = false, onExpandClick = undefined, variant = "light", enableMagnify = false, }) => {
    var _a;
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0);
    const [magnifyActive, setMagnifyActive] = (0, react_1.useState)(false);
    const slidesRef = (0, react_1.useRef)(null);
    const slideRef = (0, react_1.useRef)(null);
    const magnifyRef = (0, react_1.useRef)(null);
    const zoom = 3;
    const setMagnifyBackgroundSize = () => {
        magnifyRef.current.style.backgroundSize =
            slideRef.current.offsetWidth * zoom + "px " + slideRef.current.offsetHeight * zoom + "px";
    };
    (0, react_1.useEffect)(() => {
        if (!enableMagnify || !slideRef.current || !magnifyRef.current) {
            return;
        }
        setMagnifyBackgroundSize();
        const handleMousemove = (e, initialValues) => {
            const { x, y } = getCursorPos(e);
            updateMagnifier(x, y, initialValues);
        };
        const handleResize = () => {
            setMagnifyBackgroundSize();
        };
        const w = magnifyRef.current.offsetWidth / 2;
        const h = magnifyRef.current.offsetHeight / 2;
        const initialValues = { zoom, w, h };
        const currentSlides = slidesRef.current;
        const currentMagnify = magnifyRef.current;
        currentSlides.addEventListener("mousemove", (e) => handleMousemove(e, initialValues));
        currentMagnify.addEventListener("mousemove", (e) => handleMousemove(e, initialValues));
        currentSlides.addEventListener("mouseenter", handleMouseenter);
        currentSlides.addEventListener("mouseleave", handleMouseleave);
        window.addEventListener("resize", handleResize);
        return () => {
            currentSlides.removeEventListener("mousemove", handleMousemove);
            currentMagnify.removeEventListener("mousemove", handleMousemove);
            currentSlides.removeEventListener("mouseenter", handleMouseenter);
            currentSlides.removeEventListener("mouseleave", handleMouseleave);
            window.removeEventListener("resize", handleResize);
        };
    }, [enableMagnify, slides]);
    const handleMouseenter = () => {
        setMagnifyActive(true);
    };
    const handleMouseleave = () => {
        setMagnifyActive((currentValue) => !currentValue);
    };
    const getCursorPos = (e) => {
        let x, y;
        const boundingRect = slideRef.current.getBoundingClientRect();
        x = e.pageX - boundingRect.left;
        y = e.pageY - boundingRect.top;
        /* Consider any page scrolling: */
        x = x - window.scrollX;
        y = y - window.scrollY;
        return { x, y };
    };
    const updateMagnifier = (x, y, initialValues) => {
        if (!magnifyRef.current)
            return;
        const { zoom, w, h } = initialValues;
        magnifyRef.current.style.left = x - w + "px";
        magnifyRef.current.style.top = y - h + "px";
        magnifyRef.current.style.backgroundPosition = `
            -${x * zoom - w}px -${y * zoom - h}px`;
    };
    const goToSlide = (index) => {
        const lastIndex = slides.length - 1;
        const firstIndex = 0;
        const endOfRightSlides = index > lastIndex;
        const endOfLeftSlides = index < firstIndex;
        let newIndex = index;
        if (endOfRightSlides) {
            newIndex = firstIndex;
        }
        if (endOfLeftSlides) {
            newIndex = lastIndex;
        }
        const size = slidesRef.current.clientWidth;
        if (endOfRightSlides) {
            slidesRef.current.style.transform = `translateX(${-size * (currentIndex - lastIndex)}px)`;
        }
        else if (endOfLeftSlides) {
            slidesRef.current.style.transform = `translateX(${-size * (currentIndex + lastIndex)}px)`;
        }
        else {
            slidesRef.current.style.transform = `translateX(${-size * index}px)`;
        }
        setCurrentIndex(newIndex);
    };
    const isDark = variant === "dark";
    const canExpand = !!onExpandClick;
    return (react_1.default.createElement(ImageCarousel_styles_1.Container, null,
        react_1.default.createElement(ImageCarousel_styles_1.LeftArrow, { "data-testid": "carouselLeftArrow", onClick: () => goToSlide(currentIndex - 1), "$isDark": isDark }, "\u276C"),
        react_1.default.createElement(ImageCarousel_styles_1.Slides, { ref: slidesRef, "$magnifyActive": magnifyActive }, slides.map((item, index) => (react_1.default.createElement(ImageCarousel_styles_1.Slide, { ref: index === currentIndex ? slideRef : null, key: index, "$image": item.background })))),
        enableMagnify && (react_1.default.createElement(ImageCarousel_styles_1.MagnifyGlass, { ref: magnifyRef, "$image": (_a = slides[currentIndex]) === null || _a === void 0 ? void 0 : _a.background, "$isActive": magnifyActive })),
        react_1.default.createElement(ImageCarousel_styles_1.RightArrow, { "data-testid": "carouselRightArrow", onClick: () => goToSlide(currentIndex + 1), "$isDark": isDark }, "\u276D"),
        react_1.default.createElement(ImageCarousel_styles_1.IndicatorsContainer, null, slides.map((item, index) => (react_1.default.createElement(ImageCarousel_styles_1.SlideIndicators, { key: index, "data-testid": `carouselIndicator-${index}`, onClick: () => goToSlide(index), "$isSelected": index === currentIndex },
            react_1.default.createElement(ImageCarousel_styles_1.Indicator, { "$isSelected": index === currentIndex, "$isDark": isDark }))))),
        canExpand && (react_1.default.createElement(ImageCarousel_styles_1.ExpandContainer, { "data-testid": "expandContainer", onClick: onExpandClick, "$isDark": isDark }, isExpanded ? react_1.default.createElement(icons_1.Collapse, null) : react_1.default.createElement(icons_1.Expand, null)))));
};
exports.ImageCarousel = ImageCarousel;
//# sourceMappingURL=ImageCarousel.js.map